/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-27T09:07:17-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-27T16:57:38-07:00
*/



import React, { Component } from 'react';

import ManageSubscription from './ManageSubscription';
import ChangePassword from './ChangePassword';
import ChangeEmail from './ChangeEmail';
import DeactivateAccount from './DeactivateAccount';
import Container from '../../blocks/Container';

class GeneralSettings extends Component {
  render() {
    return (
      <div>
        {this.props.isFemale ? '' :
        <ManageSubscription subscription={this.props.subscription} confirmCancel={this.props.confirmCancel} />}
        <ChangePassword errors={this.props.errors} updatePasswordForm={this.props.updatePasswordForm} />
        <ChangeEmail errors={this.props.errors} updateEmailForm={this.props.updateEmailForm} email={this.props.settings.email} />
        <DeactivateAccount />
      </div>
    );
  }
}

export default GeneralSettings;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/GeneralSettings.jsx